import CardContentDates from './cardContentDates.js';
export default CardContentDates;
